export default "__VITE_ASSET__DpAUj9vO__"